import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Header = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isSecondDropdownOpen, setIsSecondDropdownOpen] = useState(false);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [isPhotoSubOpen, setIsPhotoSubOpen] = useState(false);
  const [isVideoSubOpen, setIsVideoSubOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prevState) => !prevState);
    setIsDropdownOpen(false);
    setIsSecondDropdownOpen(false);
  };

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsDropdownOpen((prevState) => !prevState);
    setIsSecondDropdownOpen(false);
    setIsGalleryOpen(false);
  };

  const toggleSecondDropdown = (e) => {
    e.preventDefault();
    setIsSecondDropdownOpen((prevState) => !prevState);
    setIsDropdownOpen(false);
    setIsGalleryOpen(false);
  };

  const toggleGallery = (e) => {
    e.preventDefault();
    setIsGalleryOpen((prevState) => !prevState);
    setIsDropdownOpen(false);
    setIsSecondDropdownOpen(false);
    setIsPhotoSubOpen(false);
    setIsVideoSubOpen(false);
  };

  const togglePhotoSub = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsPhotoSubOpen((prevState) => !prevState);
    setIsVideoSubOpen(false);
  };

  const toggleVideoSub = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsVideoSubOpen((prevState) => !prevState);
    setIsPhotoSubOpen(false);
  };

  const closeMenus = () => {
    setIsMobileMenuOpen(false);
    setIsDropdownOpen(false);
    setIsSecondDropdownOpen(false);
    setIsGalleryOpen(false);
    setIsPhotoSubOpen(false);
    setIsVideoSubOpen(false);
  };

  useEffect(() => {
    closeMenus();

    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);

  useEffect(() => {
    const scrollLinks = document.querySelectorAll('.scroll');
    scrollLinks.forEach(link =>
      link.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
    );
  }, []);

  return (
    <>
      <div className="page_wrapper">
        <div className="backtotop">
          <a href="#" className="scroll">
            <i className="fa-solid fa-arrow-up" />
          </a>
        </div>

        <motion.header
          className={`site_header header_layout_1 ${isSticky ? 'sticky-header' : ''}`}
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="xb-header stricky" style={{ marginTop: '-8px' }}>
            <div className="container">
              <div className="d-flex justify-content-between p-2">
                <div className="site_logo">
                  <NavLink className="site_link" to="/">
                    <img src="assets/images/logo.svg" width="90px" alt="Site Logo" />
                  </NavLink>
                </div>

                <div className="d-lg-none" style={{ position: 'absolute', right: '10px' }}>
                  <button
                    className="mobile_menu_icon"
                    onClick={toggleMobileMenu}
                    aria-label="Toggle Mobile Menu"
                  >
                    <i className={`fa ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'}`} />
                  </button>
                </div>

                <div className={`main_menu ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
                  <nav className="navbar navbar-expand-lg">
                    <div
                      className={`main_menu_inner navbar-collapse ${
                        isMobileMenuOpen ? 'show' : ''
                      }`}
                    >
                      <ul className="main_menu_list unordered_list">
                        {/* <li>
                          <NavLink className="nav-link text-dark" to="/about-us">
                            About Us
                          </NavLink>
                        </li> */}
                        {/* First Dropdown */}
                        <li className={`dropdown ${isDropdownOpen ? 'show' : ''}`}>
                          <NavLink
                            className="nav-link dropdown-toggle"
                            to="#"
                            onClick={toggleDropdown}
                            role="button"
                            aria-expanded={isDropdownOpen}
                          >
                            Become a Member
                          </NavLink>
                          <ul className={`dropdown-menu ${isDropdownOpen ? 'show' : ''}`}>
                            <li>
                              <NavLink to="/become-a-member#overview" onClick={closeMenus}>
                                Overview
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/become-a-member#membership-form" onClick={closeMenus}>
                                Membership Form
                              </NavLink>
                            </li>
                          </ul>
                        </li>

                        {/* Second Dropdown (New) */}
                        {/* <li className={`dropdown ${isSecondDropdownOpen ? 'show' : ''}`}>
                          <a
                            className="nav-link dropdown-toggle"
                            href="#"
                            onClick={toggleSecondDropdown}
                            role="button"
                            aria-expanded={isSecondDropdownOpen}
                          >
                            Learning Hub
                          </a>
                          <ul className={`dropdown-menu ${isSecondDropdownOpen ? 'show' : ''}`}>
                            <li>
                              <NavLink to="/" onClick={closeMenus}>
                              Series 1
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/" onClick={closeMenus}>
                              Series 2
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/" onClick={closeMenus}>
                              Series 3
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/" onClick={closeMenus}>
                              Series 4
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/" onClick={closeMenus}>
                              Series 5
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/" onClick={closeMenus}>
                              Series 6
                              </NavLink>
                            </li>
                          </ul>
                        </li> */}

                        <li>
                          <NavLink to="/learning-hub" className="text-dark" onClick={closeMenus}>
                          Learning Hub
                          </NavLink>
                        </li>
                         <li>
                          <NavLink className="nav-link text-dark" to="/whats-happening">
                            What's Happening
                          </NavLink>
                        </li>
                         <li className={`dropdown ${isGalleryOpen ? 'show' : ''}`}>
                          <NavLink
                            className="nav-link dropdown-toggle"
                            to="#"
                            onClick={toggleGallery}
                            role="button"
                            aria-expanded={isGalleryOpen}
                          >
                            Gallery
                          </NavLink>
                          <ul className={`dropdown-menu ${isGalleryOpen ? 'show' : ''}`} style={{ minWidth: '200px' }}>
                            <li className={`dropdown-submenu ${isPhotoSubOpen ? 'show-submenu' : ''}`}>
                              <a
                                href="#"
                                className="dropdown-item d-flex justify-content-between align-items-center"
                                onClick={togglePhotoSub}
                              >
                                Photo Gallery <i className="fa-solid fa-chevron-right" style={{ fontSize: '12px' }}></i>
                              </a>
                              <ul className={`submenu ${isPhotoSubOpen ? 'show' : ''}`}>
                                <li>
                                  <NavLink to="/photos-gallery-2026" onClick={closeMenus}>
                                    Photos 2026
                                  </NavLink>
                                </li>
                                <li>
                                  <NavLink to="/photos-gallery-2025" onClick={closeMenus}>
                                    Photos 2025
                                  </NavLink>
                                </li>
                              </ul>
                            </li>
                            <li className={`dropdown-submenu ${isVideoSubOpen ? 'show-submenu' : ''}`}>
                              <a
                                href="#"
                                className="dropdown-item d-flex justify-content-between align-items-center"
                                onClick={toggleVideoSub}
                              >
                                Video Gallery <i className="fa-solid fa-chevron-right" style={{ fontSize: '12px' }}></i>
                              </a>
                              <ul className={`submenu ${isVideoSubOpen ? 'show' : ''}`}>
                                {/* <li>
                                  <NavLink to="/gallery/videos-2026" onClick={closeMenus}>
                                    Videos 2026
                                  </NavLink>
                                </li> */}
                                <li>
                                  <NavLink to="/video-gallery-2025" onClick={closeMenus}>
                                    Videos 2025
                                  </NavLink>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                        {/* <li>
                          <NavLink to="/events" className="text-dark" onClick={closeMenus}>
                          Events
                          </NavLink>
                        </li> */}
                        <li>
                          <NavLink to="/our-team" className="text-dark" onClick={closeMenus}>
                            Our Team
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/contact-us" className="text-dark" onClick={closeMenus}>
                            Contact Us
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </motion.header>
      </div>

       <style jsx>{`
        .mobile_menu_icon {
          font-size: 24px;
          cursor: pointer;
          background: none;
          border: none;
        }
        .mobile-menu-open .main_menu_inner {
          display: block;
          margin-top: -48px;
        }
        .navbar-collapse.collapse.show {
          display: block !important;
        }
        .dropdown-menu {
          display: none;
          background: white;
          border: none;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          padding: 10px 0;
        }
        .dropdown.show .dropdown-menu {
          display: block;
        }
        @media (min-width: 993px) {
          .dropdown:hover > .dropdown-menu {
            display: block;
          }
          .dropdown-submenu:hover > .submenu {
            display: block;
          }
        }
        .dropdown-submenu {
          position: relative;
        }
        .dropdown-submenu .submenu {
          display: none;
          position: absolute;
          left: 100%;
          top: -10px;
          background: white;
          min-width: 200px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          list-style: none;
          padding: 10px 0;
          z-index: 1001;
        }
        .dropdown-submenu.show-submenu .submenu {
          display: block;
        }
        .dropdown-item {
          padding: 12px 20px;
          color: #2b2b2b;
          font-weight: 600;
          font-size: 15px;
          text-decoration: none;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: all 0.3s ease;
        }
        .dropdown-item:hover {
          background: #f9f9f9;
          color: #000;
        }
        .dropdown-item.active, .dropdown-item:active {
          background-color: transparent !important;
          color: #2b2b2b !important;
        }
        .submenu li a {
          display: block;
          padding: 10px 20px;
          color: #2b2b2b;
          text-decoration: none;
          font-weight: 600;
          font-size: 15px;
          transition: all 0.3s ease;
        }
        .submenu li a:hover {
          background: #f9f9f9;
          color: #000;
        }
        @media (max-width: 992px) {
          .main_menu_inner {
            display: none;
            position: absolute;
            top: 60px;
            right: 0;
            background: white;
            width: 100%;
            z-index: 999;
            padding: 20px;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
          }
          .mobile-menu-open .main_menu_inner {
            display: block;
          }
          .dropdown-submenu .submenu {
            position: static;
            display: none;
            padding-left: 20px;
            box-shadow: none;
            border-radius: 0;
          }
          .dropdown-submenu.show-submenu .submenu {
            display: block;
          }
        }
      `}</style>
    </>
  );
};

export default Header;
